const ITEMS = [
  "Green Fuel",
  "Clean Future",
  "Carbon Natural",
  "High Calorific Value",
  "No Adhesive · No Sulphur",
  "Eco Friendly Fuel",
  "Made in Katni, India",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-emerald-900/40 bg-[#062A19]/60 py-5">
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display px-8 text-lg font-bold uppercase tracking-[0.2em] text-emerald-100/80 sm:text-xl">
                {item}
              </span>
              <span className="h-2 w-2 rotate-45 bg-emerald-500" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
